<template>
<div>
    <v-card flat tile>
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">
          Application Details
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
          <!-- retry failed jobs -->
          <app-retry-failed-jobs :client="client" />
          <!-- password retrieval -->
          <app-login-password :client="client" />
          <!-- logs url -->
          <v-btn text color="black" target="_blank" :href="logsUrl">
            <v-icon color="primary darken-1" size="25">mdi-file-sign</v-icon>
            Logs
          </v-btn>
          <!-- deploy code DISABLED FEATURE -->
          <v-btn disabled text color="primary darken-1" @click="isDeploying = !isDeploying">
            <v-icon color="primary darken-1" size="25">mdi-upload-network-outline</v-icon>
            Deploy
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-card>

    <v-card flat tile>
        <v-card-text>
        <v-row>
          <!-- api url -->
          <v-col md="3" sm="3">
            <h4 class="title">API Url</h4>
            <p class="body-1">
              <a v-if="client.api_url" :href="client.api_url">{{ client.api_url }}</a>
              <span v-else>N/A</span>
            </p>
          </v-col>
          <!-- admin url -->
          <v-col md="3" sm="3">
            <h4 class="title">Admin Url</h4>
            <p class="body-1">
              <a v-if="client.admin_url" :href="client.admin_url">{{ client.admin_url }}</a>
              <span v-else>N/A</span>
            </p>
          </v-col>
          <!-- health check status -->
          <v-col md="6" sm="6">
              <h4 class="title">
                Health status
                <v-icon size="25" color="primary" v-if="client.is_healthy">mdi-progress-check</v-icon>
                <v-icon size="25" color="warning" v-else>mdi-progress-alert</v-icon>
              </h4>
              <p class="body-1">
                <a target="_blank" v-if="client.api_url" :href="client.api_url + '/api/v1/healthCheck'">
                  {{ client.api_url + '/api/v1/healthCheck' }}
                </a>
              </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- code status card -->
    <v-card flat tile v-if='gitlabProjects'>
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">
          Code Status
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <!-- Gitlab details -->
          <v-col md="2" sm="3">
            <h4 class="title">Admin Release</h4>
            <p class="body-1">
              <a style="text-decoration: none" target="_blank" :href="gitlabProjects.admin.link">
                {{ gitlabProjects.admin.tag_name || 'N/A' }}
              </a>
            </p>
          </v-col>
          <v-col md="2" sm="3">
            <h4 class="title">Api Release</h4>
              <p class="body-1">
                <a target="_blank" :href="gitlabProjects.api.link">
                  {{ gitlabProjects.api.tag_name || 'N/A' }}
                </a>
            </p>
          </v-col>
          <!-- IOS Details -->
          <v-col md="2" sm="3">
            <h4 class="title">[IOS] Version</h4>
            <p class="body-1">{{ parsedTags['IosVersion'] || 'N/A' }}</p>
          </v-col>
          <v-col md="2" sm="3">
            <h4 class="title">[IOS] Build Max</h4>
            <p class="body-1">{{ parsedTags['IosBuild'] || 'N/A' }}</p>
          </v-col>
          <v-col md="2" sm="3">
            <h4 class="title">[IOS] Build Min</h4>
            <p class="body-1">{{ parsedTags['IosBuildMin'] || 'N/A' }}</p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
</div>
</template>

<script>
import appLoginPassword from '../instance/appLoginPassword.vue'
import AppRetryFailedJobs from '../instance/appRetryFailedJobs.vue'
export default {
  components: { appLoginPassword, AppRetryFailedJobs },
  name: 'client-application',
  data: () => (
    { 
      isDeploying: false,
      logsUrl: ""
    }
  ),
  props: {
    client: { required: true },
    gitlabProjects: { required: true },
    parsedTags: { required: true },
  },
  mounted () {
    this.generateLogsUrl()
  },
  methods: {
    generateLogsUrl () {
      this.logsUrl = "https://ctrax.analytics.cannatrax.net/app/discover#/?_a=(columns:!(labels.node_hostname,message),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:e94353f0-b234-11ec-a813-e5edee4e2fee,key:labels.node_hostname,negate:!f,params:(query:"+ this.client.dns +".api.cannatrax.net),type:phrase),query:(match_phrase:(labels.node_hostname:" + this.client.dns + ".api.cannatrax.net)))),index:e94353f0-b234-11ec-a813-e5edee4e2fee,interval:auto,query:(language:kuery,query:''),sort:!(!('@timestamp',desc)))&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))"
    }
  }
}
</script>

<style>

</style>
